import { CellContextMenuEvent, GetContextMenuItemsParams } from 'ag-grid-community';
import { IExcelExportParamsProvider } from './i-excel-export-params-provider';
import { CustomerSettings } from "../../classes/customer-settings";
import { autoinject } from "aurelia-dependency-injection";
@autoinject()
export class AgGridCustomContextMenu {
  public exportToExcel: IExcelExportParamsProvider;

  constructor(protected customerSettings: CustomerSettings) { }

  async setExcelParams(exportToExcel: IExcelExportParamsProvider) {
    this.exportToExcel = exportToExcel;
  }

  getParams() {
    return {
      columnSeparator: ';',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getContextMenuItemsAsync(_params: CellContextMenuEvent, _viewmodel: unknown) {
    const MenuItems: any[] = [
      'autoSizeAll',
      'resetColumns',
    ];
    return MenuItems;
  }

  // this cannot be async and excelParams need to be reference to a function that gives the excel export params
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getContextMenuItems(params: GetContextMenuItemsParams | CellContextMenuEvent, _viewmodel: unknown) {
    // Create basic meenuItems (Built in ag-grid)
    const MenuItems: any[] = [
      'autoSizeAll',
      'resetColumns',
    ];
    MenuItems.push({
      name: 'Size Columns to fit',
      action: () => {
        params.api.sizeColumnsToFit();
      },
    });
    MenuItems.push('separator');
    MenuItems.push({
      name: 'Reset filter',
      action: () => {
        params.api.setFilterModel(null);
        if (params.api.getGridOption('enableAdvancedFilter')) {
          params.api.setAdvancedFilterModel(null);
        }
      },
    });
    MenuItems.push('separator');
    if (this.exportToExcel) {
      MenuItems.push({
        name: 'Export To Csv',
        action: async () => {
          params.api.exportDataAsCsv(this.getParams());
        },
      });
      MenuItems.push({
        name: 'Export To Excel',
        action: async () => {
          const excelparams = await this.exportToExcel.getExportToExcelParams(params);
          params.api.exportDataAsExcel(excelparams);
        },
      });
    }
    return MenuItems;
  }

}
